
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"11.818","height":"14"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"transform":"translate(-2)","fill":"none","stroke":"#a2a2a2","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"2"}},[_c('path',{attrs:{"data-name":"Path 32032","d":"M12.818 5.909C12.818 9.727 7.909 13 7.909 13S3 9.727 3 5.909a4.909 4.909 0 119.818 0z"}}),_c('circle',{attrs:{"data-name":"Ellipse 391","cx":"2","cy":"2","r":"2","transform":"translate(6 4)"}})])])
          )
        }
      }
    